var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-share-sheet',{attrs:{"value":_vm.value,"title":"立即分享给好友","options":_vm.options},on:{"input":function($event){return _vm.$emit('input',$event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }